/* eslint-disable import/no-anonymous-default-export */
export default {
    getPublications: "/api/publications",
    singlePublication: "/api/publications/find/:slug",
    getCategories: "/api/categories",
    searchTerm: "/api/publications/search/:searchTerm"
}